import { UserVaccountAider } from "./user-vaccounts.aider";

/**
 * @typedef {object} UserVaccount
 *
 * @property {string} _id
 *
 * @property {string} _user
 *
 * @property {string} bankCode
 * @property {string} bankName
 * @property {string} number
 * @property {string} holder
 * @property {string} [vaccount]
 * @property {string} [waccount]
 *
 * @property {object} sender
 * @property {string} sender.name
 * @property {string} sender.phone
 * @property {string} sender.birth
 * @property {object} sender.account
 * @property {string} sender.account.bankCode
 * @property {string} sender.account.bankName
 * @property {string} sender.account.number
 * @property {string} [sender.account.holder]
 *
 * @property {string} pg
 * @property {string} trackId
 *
 * @property {boolean} isEnabled
 * @property {boolean} isExpired
 *
 * @property {Date|string|number} [createdAt]
 * @property {Date|string|number} [updatedAt]
 * @property {Date|string|number} [enabledAt]
 * @property {Date|string|number} [expiredAt]
 * @property {Date|string|number} [expiresAt]
 */

/**
 * @param {Partial<UserVaccount>} data
 * @returns {UserVaccount}
 */
export function initUserVaccount(data) {
    data = {
        ...(data || {}),

        _id: data?._id,

        _user: data?._user || null,

        bankCode: data?.bankCode || null,
        bankName: data?.bankName || null,
        number: data?.number || null,
        holder: data?.holder || null,

        sender: {
            ...(data?.sender || {}),

            name: data?.sender?.name || null,
            phone: data?.sender?.phone || null,
            birth: data?.sender?.birth || null,

            account: {
                ...(data?.sender?.account || {}),

                bankCode: data?.sender?.account?.bankCode || null,
                bankName: UserVaccountAider.getBankName(data?.sender?.account),
                number: data?.sender?.account?.number || null,
                holder: data?.sender?.name || null,
            },
        },

        pg: data?.pg || null,
        trackId: data?.trackId || null,

        isEnabled: data?.isEnabled ?? false,
        isExpired: data?.isExpired ?? false,

        createdAt: data?.createdAt,
        updatedAt: data?.updatedAt,
        enabledAt: data?.enabledAt,
        expiredAt: data?.expiredAt,
        expiresAt: data?.expiresAt,
    };

    if (!data._id) delete data._id;
    if (!data.createdAt) delete data.createdAt;
    if (!data.updatedAt) delete data.updatedAt;
    if (!data.enabledAt) delete data.enabledAt;
    if (!data.expiredAt) delete data.expiredAt;
    if (!data.expiresAt) delete data.expiresAt;

    data.vaccount = UserVaccountAider.getAccountText(data);
    if (!data.vaccount) delete data.vaccount;

    data.waccount = UserVaccountAider.getAccountText(data.sender.account);
    if (!data.waccount) delete data.waccount;

    return data;
}
